import React, { Component } from 'react';
import {connect} from "react-redux";

import ContainerDimensions from "react-container-dimensions";
import {Layer, Stage, Text} from "react-konva";
import CachedImage from "../CachedImage";
import {Button} from "reactstrap";
import TemplateLayouts from "./TemplateLayouts";
import {setPhase, setFaceObjects, closeTour, setTextValue, setTextFont, setTextColor, setTextSize} from "../../actions";
import Tour from "reactour";
import ChoiceWidget from "../ChoiceWidget";
import {SimpleColorPicker} from "../ColorPicker";

class TemplateText extends Component {
  state = {

  }

  sizeRef = {};

  constructor(props) {
    super(props);
    this.renderImage = this.renderImage.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }

  handleBack() {
    this.props.setPhase(1);
  }

  handleNext() {
    let objects = [];
    const paperX = 550;
    const paperY = 910;

    const currentLayout = this.props.meishi.layouts[this.props.meishi.currentLayout];

    currentLayout.objects.forEach((obj) => {
      const font = this.props.meishi.textFonts[obj.id] || this.props.fonts.fonts[0];
      const color = this.props.meishi.textColors[obj.id] || '#000000';
      objects.push({
        id: obj.id,
        type: 'text',
        isRemovable: true,
        props: {
          text: this.props.meishi.textValues[obj.id],
          fill: color,
          fontFamily: font.value,
          x: obj.x * this.sizeRef.canvasWidth,
          y: obj.y * this.sizeRef.canvasHeight,
          fontSize: obj.fontSize * this.sizeRef.sizeRatio
        },
        font: {label: '源ノ角ゴシック', value: 'sourcehansansr', bold: 'sourcehansansb', fontplus: false, lang: 'ja'},
      });
    });

    this.props.setFaceObjects(objects, this.sizeRef);
  }
  render() {
    const template = this.props.meishi.layouts[this.props.meishi.currentLayout];

    return (
      <div className="t-content t-face-container">
        <div className="t-content-left">
          <div className="t-container-sidebar">
            <div className="t-container-sidebar-pane-top">
              <div className="phase-title">
                <small>STEP4</small>
                <span>テキスト入力</span>
              </div>
            </div>
            <TemplateLayouts />
          </div>
        </div>

        <div className="t-content-right t-content-right-flex">
          <div className="t-container-canvas">
            <div className="t-content-right-toolbar">
              <div className="actions">
                <Button onClick={this.handleBack}>前へ: 画像編集</Button>
                <Button color="info" onClick={this.handleNext}>次へ: 自由編集</Button>
              </div>
              <div>テキストを入力してください</div>
            </div>
            <div className="t-face-text-template">
              <div className="t-face-text-preview">
                <ContainerDimensions>
                  { ({ width, height }) => {
                    const paperX = 550;
                    const paperY = 910;
                    //const ratio  = paperY / paperX;
                    const sizeRatio = (height - 50) / paperY;

                    const canvasHeight = paperY * sizeRatio;
                    const canvasWidth = paperX * sizeRatio;
                    const imageRatio = this.props.meishi.croppedImage.width / this.props.meishi.croppedImage.height;
                    const imageProps = {
                      id: 'face',
                      ...this.props.meishi.finalImage,
                      props: {
                        width: canvasWidth,
                        height: canvasWidth / imageRatio,
                        x: this.props.meishi.finalImage.x * sizeRatio,
                        y: this.props.meishi.finalImage.y * sizeRatio - canvasHeight * 0.1,
                        scaleX: this.props.meishi.finalImage.scaleX,
                        scaleY: this.props.meishi.finalImage.scaleY,
                      }
                    }

                    this.sizeRef = {
                      canvasWidth, canvasHeight, sizeRatio
                    };

                    const currentLayout = this.props.meishi.layouts[this.props.meishi.currentLayout];

                    return (
                      <Stage width={canvasWidth} height={canvasHeight} style={{backgroundColor: "#fff", border: '1px solid #000'}}>
                        <Layer x={0} y={0}>
                          {this.renderImage(imageProps)}
                        </Layer>
                        <Layer listening={false}>
                          {currentLayout.objects.map((object, i) => {
                            const font = this.props.meishi.textFonts[object.id] || this.props.fonts.fonts[0];
                            const color = this.props.meishi.textColors[object.id] || '#000000';
                            const text = this.props.meishi.textValues[object.id];

                            if (text) {
                              return <Text
                                key={i}
                                x={object.x * canvasWidth}
                                y={object.y * canvasHeight}
                                fontSize={object.fontSize * sizeRatio}
                                text={this.props.meishi.textValues[object.id]}
                                fontFamily={font.value}
                                fill={color}
                              />;
                            } else {
                              return <Text
                                key={i}
                                x={object.x * canvasWidth}
                                y={object.y * canvasHeight}
                                fontSize={object.fontSize * sizeRatio}
                                text={object.sample}
                                fontFamily={font.value}
                                fill={'#cccccc'}
                              />;
                            }


                          })}
                          {/*<Rect x={0} y={0} height={canvasHeight * 0.1} width={canvasWidth} fill="#000000" opacity={0.5} />*/}
                          {/*<Rect x={0} y={0} height={canvasHeight * 0.97} width={canvasWidth * 0.05} fill="yellow" opacity={0.3} />*/}
                          {/*<Rect x={canvasWidth - canvasWidth * 0.05} y={0} height={canvasHeight * 0.97} width={canvasWidth * 0.05} fill="yellow" opacity={0.3} />*/}
                          {/*<Rect x={0} y={canvasHeight * 0.97} height={canvasHeight * 0.03} width={canvasWidth} fill="yellow" opacity={0.3} />*/}
                        </Layer>
                      </Stage>
                    );
                  }}
                </ContainerDimensions>
              </div>
              <div className="t-face-text-form">
                <div className="alert alert-info">
                  次の自由編集では位置の調整・ロゴの追加が可能です。
                </div>

                {template.objects.map((object, i) => {
                  const font = this.props.meishi.textFonts[object.id] || this.props.fonts.fonts[0];
                  const color = this.props.meishi.textColors[object.id] || '#000000';

                  return (
                    <div key={i} className="form-group" onClick={() => {this.props.closeTour(5)}}>
                      <label>{object.label}</label>
                      <input type="text" className="form-control" onChange={(e) => {
                        this.props.setTextValue(object.id, e.target.value);
                        // this.setState({
                        //   [object.id]: e.target.value
                        // })
                      }} value={this.props.meishi.textValues[object.id] || ''} placeholder={object.sample} />
                      <ChoiceWidget
                        choices={this.props.fonts.fonts}
                        data={font}
                        onSelect={(font) => {
                          this.props.setTextFont(object.id, font);
                        }}
                        groupBy="lang"
                        renderLabel={(value) => {
                          return <span style={{fontFamily: value.value}}>{value.label}</span>;
                        }}
                        renderChoice={(value) => {
                          return <span style={{fontFamily: value.value}}>{value.label}</span>;
                        }}
                        renderHeader={(key) => {
                          return <span>{this.props.fonts.languages[key]}</span>;
                        }}
                      />
                      <SimpleColorPicker value={color} name={"cp-" + i} onChange={(color) => {
                        this.props.setTextColor(object.id, color.hex);
                      }} iconOnly/>
                      <div className="btn btn-secondary" onClick={() => {
                        this.props.setTextSize(object.id, (object.fontSize - 1));
                      }}>小さく</div>
                      <div className="btn btn-secondary" onClick={() => {
                        this.props.setTextSize(object.id, (object.fontSize + 1));
                      }}>大きく</div>
                    </div>

                  );
                })}
              </div>

            </div>
          </div>

        </div>

        {/*<Tour*/}
        {/*  steps={*/}
        {/*    [{*/}
        {/*      selector: '.t-container-sticker-list',*/}
        {/*      content: '名刺のレイアウトを選択してください',*/}
        {/*    },{*/}
        {/*      selector: '.t-face-text-form',*/}
        {/*      content: '名刺に印刷するテキストを入力してください',*/}
        {/*    }]*/}
        {/*  }*/}
        {/*  isOpen={this.props.meishi.tour[4]}*/}
        {/*  onRequestClose={() => { this.props.closeTour(4) }}*/}
        {/*  showNumber={false}*/}
        {/*/>*/}
      </div>
    );
  }

  renderImage(object) {
    return (
      <CachedImage
        name={object.id} src={object.src} props={{...object.props}}
        draggable={false} inline={true}

      />
    );
  }
}

export default connect(f => f, {
  setPhase, setFaceObjects, closeTour, setTextValue, setTextFont, setTextColor, setTextSize
})(TemplateText);



// WEBPACK FOOTER //
// ./src/components/Face/TemplateText.js